module.exports = __webpack_public_path__ + "img/gift.fd7b52b3.svg";